import { TypedUseSelectorHook, useSelector } from 'react-redux'
import type { State } from '.'

export const useAppSelector: TypedUseSelectorHook<State> = useSelector
